const UnitValues = [
  {
    name: "MB",
    value: "M"
  },
  {
    name: "GB",
    value: "G"
  }
]
export default UnitValues;